// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1MazE","header":"PatientBlock_header__WN5DR","label":"PatientBlock_label__3uboj","option":"PatientBlock_option__1yDo6"};